import { Input } from '@frontend/shadcn/components/ui/input';
import { PlusIcon, MinusIcon, CircleInfoIcon, DollarSignIcon, TrashIcon } from '@revfluence/fresh-icons/solid/esm';
import React from 'react';
import { AccordionContent, AccordionItem, AccordionTrigger } from '@frontend/shadcn/components/ui/accordion';
import { RichTextEditor, Switcher } from '@frontend/app/refresh-components';
import { Button } from '@frontend/shadcn/components/ui/button';
import { Switch } from '@revfluence/fresh';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRecruitment, useAmplifyHomePage } from '../RecruitmentContext';
import { getIconOptionByName, ImageIconSelector } from '../../../CampaignPage/components/ImageIconSelector';

export const AmplifyPerksSection = () => {
  const {
    setAmplifyPerksTitle,
    setAmplifyPerksDescription,
    setAmplifyPerksHasDescription,
    setAmplifyPerksShowSection,
    setAmplifyPerksListStyleType,
    addAmplifyPerksListItem,
    removeAmplifyPerksListItem,
    setAmplifyPerksListItemText
  } = useRecruitment();

  const homePage = useAmplifyHomePage();

  if (!homePage) {
    return null;
  }

  const {
    perks,
  } = homePage;

  const {
    title,
    description,
    hasDescription,
    listStyleType,
    listItems,
    showSection,
  } = perks;

  return (
    <AccordionItem value="perks" className="border-b-0">
      <AccordionTrigger>
        <div className="flex items-center gap-2 w-full">
          <div className="w-6 h-6 bg-green-4 rounded-lg text-primary-foreground flex items-center justify-center">
            <DollarSignIcon fontSize={12} />
          </div>
          <span className="text-base font-medium">Perks</span>
          <div className="ml-auto mr-2 flex items-center justify-center" onClick={(e) => e.stopPropagation()}>
            <Switch
              checked={showSection}
              onChange={(checked) => setAmplifyPerksShowSection(checked)}
              size="small"
            />
          </div>
        </div>
      </AccordionTrigger>
      <AccordionContent>
        {/* Title Section */}
        <div className="flex flex-col gap-2">
          <label htmlFor="amplifyPerksTitle" className="text-xs font-medium text-foreground">Title <span className="text-primaryMuted font-normal">(Required)</span></label>
          <div className="px-[1px]">
            <Input id="amplifyPerksTitle" placeholder="Join Our Affiliate Program!" value={title} onChange={(e) => setAmplifyPerksTitle(e.target.value)} />
          </div>
        </div>

        {/* Description Section */}
        <div className="mt-2">
          {hasDescription && (
          <div className="flex flex-col items-start gap-2">
            <Button
              variant="link"
              className="gap-2 pl-0"
              onClick={() => setAmplifyPerksHasDescription(false)}
              size="xs"
            >
              <MinusIcon />
              Remove Description
            </Button>
            <RichTextEditor
              placeholder="Welcome to your page! Write something amazing about your brand and give creators more information about this collaboration."
              value={description}
              onChange={setAmplifyPerksDescription}
              className="[&_.ql-editor]:min-h-[100px]"
            />
          </div>
            )}
          {!hasDescription && (
          <Button
            variant="link"
            className="gap-2 pl-0"
            onClick={() => setAmplifyPerksHasDescription(true)}
            size="xs"
          >
            <PlusIcon />
            Add Description
          </Button>
            )}
        </div>

        {/* List Section */}
        <div className="mt-4">
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-1">
              <label className="text-xs font-medium text-foreground">List</label>
              <CircleInfoIcon fontSize={12} className="text-grey-4" />
            </div>
            <Button variant="ghost" size="xs">
              <TrashIcon className="text-destructive" />
            </Button>
          </div>
          <Switcher
            items={[{
                key: 'number',
                label: 'Number',
              }, {
                key: 'bullet',
                label: 'Bullet',
              }, {
                key: 'icon',
                label: 'Icon',
              }, {
                key: 'none',
                label: 'None',
              }]}
            type="single"
            activeKeys={[listStyleType]}
            onChange={(value) => setAmplifyPerksListStyleType(value[0] as 'number' | 'bullet' | 'icon' | 'none')}
          />

          {/* List Items */}
          <div className="flex flex-col gap-4 mt-4">
            {
                listItems.map((item, index) => (
                  <div key={index} className="space-y-1">
                    <div className="flex items-center justify-between gap-1">
                      <label className="text-xs font-medium">List Item</label>
                      <Button variant="ghost" size="xs" onClick={() => removeAmplifyPerksListItem(index)}>
                        <TrashIcon className="text-destructive" />
                      </Button>
                    </div>
                    <div className="flex items-start space-x-2 px-[1px]">
                      {listStyleType === 'icon' && (
                      <ImageIconSelector
                        iconName="sack-dollar"
                        imageUrl=""
                        onImageChange={() => {}}
                        onIconChange={(icon) => setAmplifyPerksListItemText(index, item.text, icon)}
                        onImageUrlChange={() => {}}
                        onlyIcon
                        triggerBody={
                          <Button variant="outline" size="headerIcon">
                            <FontAwesomeIcon icon={getIconOptionByName(item.icon || 'sack-dollar')?.icon} className="h-3 w-3" />
                          </Button>
                        }
                      />
                      )}
                      <RichTextEditor
                        excludeModules={['link']}
                        value={item.text}
                        onChange={(value) => setAmplifyPerksListItemText(index, value, item.icon)}
                      />
                    </div>
                  </div>
                ))
              }
          </div>

          <Button
            variant="link"
            className="gap-2 pl-0 mt-4"
            onClick={() => addAmplifyPerksListItem({ text: '' })}
            size="xs"
          >
            <PlusIcon />
            Add List Item
          </Button>
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};
